export const BRAND = {
  name: "MentorAI Capital",
  short: "MentorAI",
  tagline: "Systematic futures. Risk first.",
  legalEntity: "MentorAI Capital LLC",
  location: "Delaware, USA",
  contactEmail: "clients@mentorai.capital",
  accessEmail: "access@mentorai.capital",
  social: {
    linkedin: "https://www.linkedin.com/company/mentorai-capital",
    x: "https://x.com/mentoraicapital",
  },
};
